import { Component, inject } from '@angular/core';
import { ParkerStateService } from '../services/state/parker-state.service';
import { AuthService } from '../services/auth-security/auth.service';
import { environment } from 'src/environments/environment';
import { AppGeneralStateService } from 'src/app/app-general-state.service';

@Component({
  selector: 'cm-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
})
export class NavComponent {
  currentUser: string = '';
  topNavClass: string = '';
  urlDomain: string = '';

  //SERVICES
  public parkerStateService = inject(ParkerStateService);
  public _appGeneralState = inject(AppGeneralStateService);

  constructor() {
    this.topNavClass = environment.ClassTopNav;
    this.urlDomain = environment.UrlDomain;
  }

  isUserAdmin(): boolean {
    return true;
  }
}
